import { render } from "./HomepageParalympic.vue?vue&type=template&id=14fa80c8&scoped=true"
import script from "./HomepageParalympic.vue?vue&type=script&lang=js"
export * from "./HomepageParalympic.vue?vue&type=script&lang=js"

import "./HomepageParalympic.vue?vue&type=style&index=0&id=14fa80c8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14fa80c8"]])

export default __exports__